import type { ReactNode } from 'react'
import { Modal, ModalContent } from '@structural-climbing/ui'
import { useIsMobile } from '../lib/useIsMobile'

interface Props {
  onClose: () => void
  /** False while saving, or while the person must answer before leaving. */
  isDismissable?: boolean
  /** Width on a wide screen. On a phone every dialog fills the screen. */
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
  /** Show HeroUI's corner close button, for dialogs with no Cancel or Close of their own. */
  showCloseButton?: boolean
  children: ReactNode
}

/**
 * The frame for every gym-app dialog: a HeroUI Modal, so focus, Escape and the
 * backdrop behave the same everywhere, and full screen on a phone so a form
 * never ends up squeezed between the keyboard and the edges.
 */
export function GymDialog({
  onClose,
  isDismissable = true,
  size = 'md',
  showCloseButton = false,
  children,
}: Props) {
  const isMobile = useIsMobile()
  return (
    <Modal
      isOpen
      size={isMobile ? 'full' : size}
      placement="center"
      scrollBehavior="inside"
      hideCloseButton={!showCloseButton}
      isDismissable={isDismissable}
      isKeyboardDismissDisabled={!isDismissable}
      onOpenChange={(open) => {
        if (!open && isDismissable) onClose()
      }}
    >
      <ModalContent className="overflow-y-auto">{children}</ModalContent>
    </Modal>
  )
}
